import PropTypes from 'prop-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = ".kof-radio-button-group .row {\n  display: flex;\n  height: 1.5em;\n  align-items: center;\n}\n.kof-radio-button-group .row label {\n  margin-left: 8px;\n}";
  const fileName = "RadioButtonGroup_RadioButtonGroup_cb839322-da0e-44f6-89e0-cfd198b553e3";
  const element = document.querySelector("style[data-sass-component='RadioButtonGroup_RadioButtonGroup_cb839322-da0e-44f6-89e0-cfd198b553e3']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function RadioButtonGroup(props) {
  return /*#__PURE__*/_jsx("div", {
    className: 'kof-radio-button-group',
    children: props.items.map(item => {
      const checked = props.value === item.value;
      const onChange = !props.disabled ? () => props.onChange(item.value) : null;
      return /*#__PURE__*/_jsxs("div", {
        className: 'row',
        children: [/*#__PURE__*/_jsx("input", {
          type: 'radio',
          value: item.value,
          checked: checked,
          onChange: onChange,
          disabled: props.disabled
        }), /*#__PURE__*/_jsx("label", {
          onClick: onChange,
          children: item.label
        })]
      }, item.value);
    })
  });
}
RadioButtonGroup.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
export { RadioButtonGroup };